import { useWindowDimensions } from "@app/hooks";
import React, { useContext } from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";

import { Text, View } from "@/styles/reactnative";
import { ThemeContext } from "@/theme/ThemeProvider";
import {MobileCalVW, useIsMobile} from "@utils/CalVW.tsx";

const StyledHeaderView = styled(View)`
  width: 100%;
  height: 60px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  background: linear-gradient(
    135deg,
    ${({theme}) => theme.itemBg || '#ffffff'} 0%,
    ${({theme}) => theme.COLORS.primary || '#007bff'}10 100%
  );
  padding: 0 24px;
  position: relative;
  
  &::before {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    height: 1px;
  }
`;

const StyledHeaderCell = styled(View)`
  width: 20%;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  
  &:not(:last-child)::after {
    content: '';
    position: absolute;
    right: 0;
    top: 50%;
    transform: translateY(-50%);
    width: 1px;
    height: 20px;
    background: ${({theme}) => theme.COLORS.border || 'rgba(255, 255, 255, 0.1)'};
  }
`;

interface StyledHeaderTextProps {
  isMobile?: boolean;
}

const StyledHeaderText = styled(Text)<StyledHeaderTextProps>`
  font-size: ${props => props.isMobile ? `${MobileCalVW(10)}px` : '15px'};
  font-weight: 600;
  color: ${({theme}) => theme.COLORS.textw || '#ffffff'};
  text-transform: uppercase;
  letter-spacing: 0.5px;
  transition: all 0.3s ease;
  
  &:hover {
    color: ${({theme}) => theme.COLORS.primary || '#007bff'};
    transform: translateY(-1px);
  }
`;

const AssetDerivativesTableHeader = ({ header }) => {
  const IsMobile = useIsMobile();
  const { t } = useTranslation();
  
  return (
    <StyledHeaderView>
      {header?.map((item: any, index: number) => (
        <StyledHeaderCell key={index.toString()}>
          <StyledHeaderText isMobile={IsMobile}>
            {item && t(item)}
          </StyledHeaderText>
        </StyledHeaderCell>
      ))}
    </StyledHeaderView>
  );
};

export default AssetDerivativesTableHeader;
